import React, {useState, useEffect} from "react";
import {ReactComponent as ArrowUp} from "../icons/arrow_up.svg";
import styled from "styled-components";

const ButtonUp = styled.button`    
    border: 1px solid black;
    cursor: pointer;
    display:flex;
    justify-content: center;
    align-items: center; 
    background-color: #343D45;
    height: 56px;
    width: 56px;
    border-radius:50%;
     &:active {
        outline: none;
    };
    &:focus {
        outline: none;
    };
`;
ButtonUp.displayName = 'ButtonUp';

const SwimBlock = styled.div`
    position: fixed;
    right: 24%;
    bottom: 5%;
    z-index: 9999;

  /* Мобильная версия */
  @media (max-width: 821.98px) {
    right: 7px;
    bottom: 160px;
  }
  
`;
SwimBlock.displayName = 'SwimBlock';

export function UpButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const root = document.getElementById('id-scroll');
    if (!root) return;

    const onScroll = () => {
      setVisible(root.scrollTop > 100);
    };

    root.addEventListener('scroll', onScroll);
    onScroll(); // Проверить сразу

    return () => root.removeEventListener('scroll', onScroll);
  }, []);

  const upScroll = () => {
    const root = document.getElementById('id-scroll');
    root && root.scrollTo({ top: 0, behavior: 'smooth' });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!visible) return null;

  return (
    <SwimBlock>
      <ButtonUp type="button" onClick={upScroll}>
        <ArrowUp />
      </ButtonUp>
    </SwimBlock>
  );
}


export const UpButtonClear: React.FC<{visible: boolean, onClick: () => void}> = ({visible, onClick}) =>  {

  if (!visible) return null;

  return (
      <SwimBlock>
        <ButtonUp type="button" onClick={onClick}>
          <ArrowUp />
        </ButtonUp>
      </SwimBlock>
  );
}